export default __webpack_public_path__ + "static/media/whack_a_moji.f7382be4.png";